import { render } from "./DevelopmentSpacesView.vue?vue&type=template&id=16eee83d&scoped=true&ts=true"
import script from "./DevelopmentSpacesView.vue?vue&type=script&lang=ts"
export * from "./DevelopmentSpacesView.vue?vue&type=script&lang=ts"

import "./DevelopmentSpacesView.vue?vue&type=style&index=0&id=16eee83d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16eee83d"]])

export default __exports__